import { createContext, useContext } from 'react';
import { TileDraggableContextValue } from './types';

const TileDraggableContext = createContext<TileDraggableContextValue | null>(
  null
);

export const TileDraggableProvider = TileDraggableContext.Provider;

/**
 * Hook to access drag state from within a TileDraggable wrapper.
 * Returns null if the component is not wrapped in TileDraggable.
 */
export const useTileDraggableContext = (): TileDraggableContextValue | null => {
  return useContext(TileDraggableContext);
};

/**
 * Hook that throws if used outside of TileDraggable context.
 * Use this when drag functionality is required.
 */
export const useRequiredTileDraggableContext =
  (): TileDraggableContextValue => {
    const context = useContext(TileDraggableContext);

    if (!context) {
      throw new Error(
        'useRequiredTileDraggableContext must be used within a TileDraggable'
      );
    }

    return context;
  };
